<template>
  <div
    class="login login-v1 d-block"
    :class="environment == 'staging' ? 'staging' : ''"
  >
    <div class="login-container">
      <div class="row mx-0 p-3 bg-white bg-opacity-25">
        <div
          v-for="(appMode, index) in appModes"
          :key="index"
          class="col-md-1 text-center pt-2"
        >
          <img
            :src="require(`@/assets/img/${appMode.logo}`)"
            class="img-fluid"
            style="max-height: 40px"
          />
        </div>
        <div class="col-md-8">
          <div class="login-content fs-13px h-100">
            <form @submit.prevent="login" class="h-100 p-0">
              <div class="row align-items-center h-100 w-100 p-0">
                <div class="col-md-4">
                  <div class="form-floating">
                    <input
                      type="email"
                      v-model="form.email"
                      class="form-control fs-13px h-45px"
                      id="email"
                      placeholder="Email cím"
                    />
                    <label for="email" class="d-flex align-items-center py-0"
                      >Email</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-floating">
                    <input
                      type="password"
                      v-model="form.password"
                      class="form-control fs-13px h-45px"
                      id="password"
                      placeholder="Jelszó"
                      autocomplete="off"
                    />
                    <label for="password" class="d-flex align-items-center py-0"
                      >Jelszó</label
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="login-buttons">
                    <button
                      type="submit"
                      class="btn h-45px btn-success d-block w-100 btn-lg"
                    >
                      Belépés
                    </button>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="login-buttons">
                    <a :href="reset_password_url" class="text-decoration-none"
                      ><button
                        type="button"
                        class="btn h-45px btn-warning d-block w-100 btn-lg"
                      >
                        Elfelejtett jelszó
                      </button></a
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  color: black !important;
  -webkit-text-fill-color: black !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
}
body {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 53%,
    rgba(79, 87, 94, 1) 100%
  );
}
.login.login-v1 {
  background-image: url("@/assets/img/tower.jpg") !important;
}
.login.staging {
  background-image: url("@/assets/img/tower_staging.png") !important;
  background-size: 60% !important;
  background-position: 100% 100%;
  background-repeat: no-repeat;
}
.form-floating > .form-control:autofill ~ label {
  opacity: 1 !important;
}
.form-floating > .form-control:not(:placeholder-shown) ~ label {
  color: #383838 !important;
}
input.form-control:autofill {
  background: green;
}
input.form-control:-webkit-autofill {
  background: red;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: black !important;
  background: transparent !important;
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: transparent !important;
}
.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  background: transparent !important;
  color: #000 !important;
}
</style>
<script>
import User from "../../apis/User";
import Location from "../../apis/Location";
import Position from "../../apis/Position";
import AppOptions from "../../config/AppOptions.vue";
import { v4 as uuidv4 } from "uuid";

export default {
  data() {
    return {
      appOptions: AppOptions,
      form: {
        email: "",
        password: "",
      },
      user: {},
      errors: [],
      environment: process.env.VUE_APP_LOGIN_IMAGE,
    };
  },
  computed: {
    reset_password_url() {
      return process.env.VUE_APP_BACK_URL + "/password/reset";
    },
    appModes() {
      return this.$store.state.appModes;
    },
  },
  created() {
    if (localStorage.getItem("darkmode") == "true") {
      this.handleSetDarkMode(true);
    }
  },

  methods: {
    login() {
      if (!localStorage.getItem("browser_session_id")) {
        localStorage.setItem("browser_session_id", uuidv4());
      }

      const browserSessionId = localStorage.getItem("browser_session_id");
      this.form.browser_session_id = browserSessionId;
      User.login(this.form)
        .then((response) => {
          this.user = response.data;
          localStorage.setItem("auth", "true");
          this.$store.commit("updateAuth", true);
        })
        .then(() => {
          Location.indexlinear().then((result) => {
            this.$store.commit("updateLocationsLinear", result.data);
          });
          Position.index().then((result) => {
            this.$store.commit("updatePositions", result.data);
          });
        })
        .then(() => {
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            if (this.user.email_verified_at == null) {
              this.$router.push({ name: "Profile" });
            } else if (this.user.available_modes.length > 1) {
              this.$router.push({ name: "AppSelector" });
            } else {
              this.$router.push({ name: "Dashboard" });
            }
          }
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    handleSetColor: function () {
      AppOptions.color = {
        componentColor: window
          .getComputedStyle(document.body)
          .getPropertyValue("--app-component-color")
          .trim(),
        componentBg: window
          .getComputedStyle(document.body)
          .getPropertyValue("--app-component-bg")
          .trim(),
        dark: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-dark")
          .trim(),
        light: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-light")
          .trim(),
        blue: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-blue")
          .trim(),
        indigo: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-indigo")
          .trim(),
        purple: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-purple")
          .trim(),
        pink: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-pink")
          .trim(),
        red: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-red")
          .trim(),
        orange: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-orange")
          .trim(),
        yellow: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-yellow")
          .trim(),
        green: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-green")
          .trim(),
        success: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-success")
          .trim(),
        teal: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-teal")
          .trim(),
        cyan: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-cyan")
          .trim(),
        white: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-white")
          .trim(),
        gray: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray")
          .trim(),
        lime: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-lime")
          .trim(),
        gray100: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-100")
          .trim(),
        gray200: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-200")
          .trim(),
        gray300: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-300")
          .trim(),
        gray400: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-400")
          .trim(),
        gray500: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-500")
          .trim(),
        gray600: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-600")
          .trim(),
        gray700: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-700")
          .trim(),
        gray800: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-800")
          .trim(),
        gray900: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-900")
          .trim(),
        black: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-black")
          .trim(),
        componentColorRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--app-component-color-rgb")
          .trim(),
        componentBgRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--app-component-bg-rgb")
          .trim(),
        darkRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-dark-rgb")
          .trim(),
        lightRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-light-rgb")
          .trim(),
        blueRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-blue-rgb")
          .trim(),
        indigoRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-indigo-rgb")
          .trim(),
        purpleRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-purple-rgb")
          .trim(),
        pinkRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-pink-rgb")
          .trim(),
        redRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-red-rgb")
          .trim(),
        orangeRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-orange-rgb")
          .trim(),
        yellowRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-yellow-rgb")
          .trim(),
        greenRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-green-rgb")
          .trim(),
        successRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-success-rgb")
          .trim(),
        tealRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-teal-rgb")
          .trim(),
        cyanRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-cyan-rgb")
          .trim(),
        whiteRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-white-rgb")
          .trim(),
        grayRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-rgb")
          .trim(),
        limeRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-lime-rgb")
          .trim(),
        gray100Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-100-rgb")
          .trim(),
        gray200Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-200-rgb")
          .trim(),
        gray300Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-300-rgb")
          .trim(),
        gray400Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-400-rgb")
          .trim(),
        gray500Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-500-rgb")
          .trim(),
        gray600Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-600-rgb")
          .trim(),
        gray700Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-700-rgb")
          .trim(),
        gray800Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-800-rgb")
          .trim(),
        gray900Rgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-gray-900-rgb")
          .trim(),
        blackRgb: window
          .getComputedStyle(document.body)
          .getPropertyValue("--bs-black-rgb")
          .trim(),
      };
    },
    handleSetDarkMode: function (value) {
      if (value === true) {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }
      localStorage.setItem("darkmode", value);
      this.handleSetColor();
    },
  },
};
</script>
